<app-chart-wrapper [title]="'Running Loans'" i18n-title="@@running_loans" [showExpandIcons]="false">
    <app-chart-filter filter [form]="runningLoansForm" [formControls]="runningLoansFormControls" (filter)="filterRunningLoans($event)"></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>
